import { Link } from 'react-router-dom';

import { media, styled } from '@pulse-web-ui/theme';

export const List = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 16px;

  ${media.desktop} {
    gap: 16px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`;

export const ProductLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.text.primary};
`;
